import RequestFilterBuilder from  './requestFilterBuilder';
import { publicationStatus, partner, typeOfContract, dealStatus } from '../../constants';
import {getDefaultSelectedMonths} from './dateFilterHelper';

export function createPriceBuckets(priceBuckets) {
    const formatter = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });

    const result = [];
    priceBuckets.forEach(bucket => {
        const minValue = formatter.format(bucket.min_value);

        if(bucket.max_value) {
        const maxValue = formatter.format(bucket.max_value);

        result.push({
            id: `${bucket.min_value}-${bucket.max_value}`,
            name: `${minValue} - ${maxValue}`
        });


        } else {
        result.push({
            id: `${bucket.min_value}-10000000`,
            name: `+${minValue}`
        });
        }
    });
    return result;
}

export function createPartnerFilterData(partners) {
  const result = [{ id: partner.makrwatch, name: 'Makrwatch'}];

  partners.forEach(currentPartner => {
    if(currentPartner.name !== 'Makrwatch') {
      result.push(currentPartner);
    }
  });

  return result;
}

export const availablePublicationStatuses = [
  publicationStatus.published,
  publicationStatus.unavailable
];

export const availableUpcomingPublicationStatuses = [
  publicationStatus.tentative,
  publicationStatus.scheduled,
  publicationStatus.inReview,
  publicationStatus.pendingReview,
  publicationStatus.publishAfterEdits,
  publicationStatus.readyToPublish,
  publicationStatus.needsEdits,
  publicationStatus.approved
];

export const availableUpcomingPublicationDealStatuses = [
  dealStatus.contract_signed
];

export function getAvaiabletypeOfContract() {
 return typeOfContract;
}

export function getDefaultRequestBuilder(upcoming=false) {
  const builder = new RequestFilterBuilder();

  const monthsWithYear = getDefaultSelectedMonths(upcoming);
  for(let monthWithYear of monthsWithYear) {
    builder.addDateParam(monthWithYear);
  }

  return builder;
}

export function getQueryStringWithPublicationStatus() {
  const builder = new RequestFilterBuilder();

  for(let status of availablePublicationStatuses) {
    builder.addStatusParam(status);
  }

  return builder.getQueryString();
}

export function getQueryStringWithUpcomingPublicationStatus() {
  const builder = new RequestFilterBuilder();

  for(let status of availableUpcomingPublicationStatuses) {
    builder.addStatusParam(status);
  }

  return builder.getQueryString();
}

export function getQueryStringWithDealStatus() {
  const builder = new RequestFilterBuilder();

  for(let status of availableUpcomingPublicationDealStatuses) {
    builder.addDealStatusParam(status);
  }

  return builder.getQueryString();
}
